import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../redux/actions";
import { default as NotificationItem } from './NotificationItem';

export class NotificationDropdown extends Component {
    constructor(props) {
        super(props);
       
        //set local state
        this.state = {
            notificationCount: 0,
            notifications: [],
            isSupervisor: this.props.user.position === this.props.position.agent ? false : true,
            actions: [],
            isReCountNeeded: false
        }
    }

    componentDidMount = () => {
        // used to stop fetch of notifications if user is not focused on agent portal tab
        document.addEventListener("visibilitychange", () => {
            if(!document.hidden) this.startPoll();
        });
        
        if(this.props.actions.fetchNotificationsAction) {
            this.props.actions.fetchNotificationsAction({ userId: this.props.user.userID, isSupervisor: this.state.isSupervisor });
        }

        this.startPoll();
    }

    componentDidUpdate = (prevProps) => {

        if(this.props.notifications !== prevProps.notifications) {
            clearTimeout(this.timeout);
            
            //set notification count
            this.setState({
                notificationCount: this.props.notifications.filter((x) => x.isAcknowledged === false).length
            })

            //set notifications
            this.setState({
                notifications: this.props.notifications
            })

            if (!this.props.isFetching) {
                this.startPoll();
            }
        }

        if(this.state.isReCountNeeded 
            && this.props.acknowledCompleted !== prevProps.acknowledCompleted) {
            var unacknowledgedNotifications = []
            this.state.notifications.forEach(element => {
                if(element.isAcknowledged === false) {
                    unacknowledgedNotifications.push(element)
                }
            })
            
            this.setState({
                notificationCount:  unacknowledgedNotifications.length,
                isReCountNeeded: false
            })

            if(unacknowledgedNotifications.length > 0 && this.props.actions.isBellRedAction) {
                this.props.actions.isBellRedAction(true)
            }
            else if(unacknowledgedNotifications.length === 0 && this.props.actions.isBellRedAction) {
                this.props.actions.isBellRedAction(false)
            }
        }
    }

    componentWillUnmount = () => clearTimeout(this.timeout);
    
    startPoll = () => {
        if(!document.hidden){
            //TODO: update this fetch to pass a filter to only retrieve un acknowledged notifications after the first initial load
            this.timeout = setTimeout(() => this.props.actions.fetchNotificationsAction({ userId: this.props.user.userID, isSupervisor: this.state.isSupervisor }), 60000);
        }
    }

    acknowledgeNotification = (notificationIds = null) => {
        
        let {notifications, isSupervisor} = this.state

        if(notificationIds === null) {           
            this.state.notifications.forEach((item, index) => {
                item.isAcknowledged = true
            });
        
            if(this.props.actions.acknowledgeNotificationAction) {

                if(this.props.actions.acknowledgeNotificationAction) {
                    this.props.actions.acknowledgeNotificationAction({
                        userId: this.props.user.userID,
                        notificationIds: notificationIds,
                        isSupervisor: isSupervisor
                    });

                    this.setState({ isReCountNeeded: true })
                }
            }
        }
        else {
            var notification = notifications.find(element => {
                                    return element.notificationIds === notificationIds
                                })

            if(notification.isAcknowledged === true) { return; }

            else {
                this.state.notifications.forEach((item, index) => {
                    if(item.notificationIds === notificationIds) {
                        item.isAcknowledged = true
                    }
                });
            }

            if(this.props.actions.acknowledgeNotificationAction) {
                this.props.actions.acknowledgeNotificationAction({
                    userId: this.props.user.userID,
                    notificationIds: notificationIds,
                    isSupervisor: isSupervisor
                });
                
                this.setState({ isReCountNeeded: true })
            }
        }
    }   

    render() {
        let { showNotificationDropDown } = this.props;
        let items = []
        
        this.state.notifications.forEach((item, index) => {
            
            items.push(
            <div key={index}>
                <NotificationItem
                    item={item}
                    isAcknowledged={item.isAcknowledged}
                    onItemClick={(id) => this.acknowledgeNotification(id)}
                 />
            </div>)
        })

        return (
            <div className={ showNotificationDropDown ? "notification-dropdown" : "notification-dropdown hide"}>
                
                <div className="notification-dropdown-title-container">
                    <span>Notifications</span>
                    <span className="notification-count">{this.state.notificationCount}</span>
                </div>

                <div className="notification-dropdown-mark-all">
                    <span></span>
                    <span>
                        {items.length > 0 ? (<a className="mark-all" href="#" onClick={() => this.acknowledgeNotification()}>{"Mark All as Read"}</a>) : ""}
                    </span>
                </div>

                <div className="notification-items custom-scroll-bar cf">
                   {items}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
	return {
        notifications: state.common.notifications,
        isFetching: state.common.isFetching,
        notificationTypeEnumItems: state.timeoff.notificationTypeEnumItems,
        user: state.common.user,
        acknowledCompleted: state.common.acknowledCompleted,
        position: state.common.position,
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(NotificationDropdown);


// WEBPACK FOOTER //
// ./src/features/common/Notifications/NotificationDropdown.js